import { createContext, useContext } from 'react';

export type ModalManagerContextValue = {
    addToStack: (modal: string) => Promise<void>;
    clearStack: () => Promise<void>;
    getHeightInStack: (modal: string) => number;
    getStack: () => string[];
    getStackSize: () => number;
    isBottomOfStack: (modal: string) => boolean;
    isInStack: (modal: string) => boolean;
    isTopOfStack: (modal: string) => boolean;
    modalStack: string[];
    popStack: () => Promise<string | undefined>;
    removeFromStack: (modal: string) => Promise<void>;
    shiftStack: () => Promise<string | undefined>;
};

const defaultContext: ModalManagerContextValue = {
    addToStack: async () => undefined,
    clearStack: async () => undefined,
    getHeightInStack: () => -1,
    getStack: () => [],
    getStackSize: () => 0,
    isBottomOfStack: () => false,
    isInStack: () => false,
    isTopOfStack: () => false,
    modalStack: [],
    popStack: async () => undefined,
    removeFromStack: async () => undefined,
    shiftStack: async () => undefined
};

export const ModalManagerContext = createContext<ModalManagerContextValue>(defaultContext);
ModalManagerContext.displayName = 'ModalManagerContext';

export const useModalManager = () => useContext(ModalManagerContext);